
import eServiceDataService from '@/services/eServiceDataService'
import axios from "axios";
//import config from '../env.js';
export default {
    name: 'Home',
    metaInfo: {
        title: 'Home',
    },
    data(){
        // console.log(lang)
        return{
            lang: '',
            username: '',
            user: '',
            config : null,
            directory: '',
        }
    },
    methods:{
        async getConfig(){
          var config;
          if(process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'uat'){
            config = "./config/config.json";
          } else {
            config = "./config/config.json";
          }
          var result = await axios.get(config);
          return result.data;
        },
        async baseUrl() {
          var config = await this.getConfig();
          return process.env.VUE_APP_ENV === 'prod' ? config.prd_eservice_url : config.uat_eservice_url;
        },
        async getuser(){
          var user = await eServiceDataService.getDisplayName()
          return user.data.recordset[0].group_name
        },
        async getDir(){
            var dir = await eServiceDataService.getGroupID()
            return dir.data.recordset[0].group_id
        },
        switchLang(lang){
            this.lang = lang
            localStorage.setItem("lang", lang)
        },
        viewpdf(type){
            //var directory = await this.getDir()
            //console.log(directory)

            //let config = await this.getConfig();
            let baseUrl;
            if(process.env.VUE_APP_ENV === 'prod'){ baseUrl = this.config.prd_eservice_url; } else { baseUrl = this.config.uat_eservice_url; }

            // var filename = directory + (type == 'checkup' ? '_checkup' : (type == 'dental' ? 'DentalList' : '_dr_movement'))
            // var filename = directory + (type == 'dental' ? '_dental_list' : (type == 'checkup' ? '_checkup' : '_dr_movement'))
            let filename
            if (type == 'dental') {
                filename = this.directory + '_dental_list'
            } else if (type == 'checkup') {
                filename = this.directory + '_checkup'
            } else if (type == 'service_catalogue') {
                filename = this.directory + '_service_catalogue'
            } else if (type == 'staff_annual_check_up') {
                filename = this.directory + '_staff_annual_check_up'
            } else if (type == 'prepaid_medical_scheme') {
                filename = this.directory + '_prepaid_medical_scheme'
            }
            /* 
            else if (type == 'non_eocss') {
                filename = directory + '_non_eocss'
            }
            */ 
            else {
                filename = this.directory + '_dr_movement'
            }

            let subPath
            if (type == 'dental') {
                subPath = 'dental_list/'
            } else if (type == 'checkup') {
                subPath = 'checkup/'
            } else if (type == 'service_catalogue') {
                subPath = 'service_catalogue/'
            } else if (type == 'staff_annual_check_up') {
                subPath = 'staff_annual_check_up/'
            } else if (type == 'prepaid_medical_scheme') {
                subPath = 'prepaid_medical_scheme/'
            }
            /*
            else if (type == 'non_eocss') {
                subPath = 'non_eocss/'
            } 
            */
            else {
                subPath = 'doctor_movement/'
            }
            // var pdf = baseUrl + "/doc/upload/" + (type == 'checkup' ? 'checkup/' : (type == 'dental' ? 'dental_list/' : 'doctor_movement/')) + directory + "/" + filename + ".pdf"
            var pdf = baseUrl + "/doc/upload/" + subPath + this.directory + "/" + filename + ".pdf"
            this.checkFileExist(pdf)
        },
        checkFileExist(file){
            var xhr = new XMLHttpRequest()
            xhr.open('HEAD', file, false)
            xhr.send()

            console.log(xhr.status)

            if(xhr.status == '404'){
                alert('File is not existed. Please help to check with IT')
            }else{
                //this.$router.push({ name: 'NewsPDF', params: { pdf: file } })
                window.open(file, '_blank')
            }
        },
        async verify(){

          const tokens = this.$cookie.get('accessToken');
          var config = await this.getConfig();
          await axios.get(config.verifyPath, {headers: {"Authorization": tokens}}).then((res) => {

            console.log(res);

            if(res.data.verified){
              localStorage.setItem('username', res.data.username)
              //localStorage.setItem('lang', 'en')
              //callbackfunc(res.data);
              //console.log("getAuth(): verified success")
            }else{
              console.log('!res.data.verified')
              console.log("verified fail")
            }

          }, () => {
            console.log('.then((res) error')
            console.log("verified fail")
          });
        }
    },
    mounted: async function(){
        if(localStorage.getItem("lang") == null || localStorage.getItem("lang") == '' || localStorage.getItem("lang") == 'undefined'){
            localStorage.setItem("lang","en")
        }
        this.lang = (localStorage.getItem("lang") != null && localStorage.getItem("lang") != '' && localStorage.getItem("lang") != 'undefined' ? localStorage.getItem("lang") : 'en')
    },
    created: async function(){
        //this.$forceUpdate()
        await this.verify()
        this.username = localStorage.getItem("username")
        this.user = await this.getuser(this.username)
        this.directory = await this.getDir()
        this.config = await this.getConfig()
        //console.log(this.username)
    }
}
